import DirectusCombobox from "../combobox";
import DirectusMultiComboboxBadges from "../multi-combobox-badges";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";

export default function TagsCombobox({
  for: forValue,
  module,
  filter,
  hideLabel,
  className,
  isMulti = false,
  values,
  onValuesChange,
  value,
  onChange,
  ...props
}) {
  const mapItem = (item) => ({
    value: item.id,
    label: item.label,
    select: item.label,
  });

  const targetFor = forValue || module;

  const tagsFilter = {
    ...(targetFor ? { for: { _eq: targetFor } } : {}),
    ...filter,
  };

  if (isMulti) {
    const multiContent = (
      <DirectusMultiComboboxBadges
        client={client}
        collection="tags"
        fields={["id", "label", "color"]}
        searchKeys={["label"]}
        filter={tagsFilter}
        sort={["label"]}
        placeholder="Select Tags"
        mapItem={mapItem}
        initialValues={values || value || []}
        onValuesChange={onValuesChange || onChange}
        {...props}
      />
    );

    if (hideLabel) {
      return <div className={className}>{multiContent}</div>;
    }

    return (
      <FilterWrapper label="Tags" className={className}>
        {multiContent}
      </FilterWrapper>
    );
  }

  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="tags"
          fields={["id", "label", "color"]}
          searchKeys={["label"]}
          filter={tagsFilter}
          sort={["label"]}
          placeholder="Select Tag"
          mapItem={mapItem}
          value={value}
          onChange={onChange}
          {...props}
        />
      </div>
    );
  }

  return (
    <FilterWrapper label="Tags" className={className}>
      <DirectusCombobox
        client={client}
        collection="tags"
        fields={["id", "label", "color"]}
        searchKeys={["label"]}
        filter={tagsFilter}
        sort={["label"]}
        mapItem={mapItem}
        value={value}
        onChange={onChange}
        {...props}
      />
    </FilterWrapper>
  );
}
